namespace TabAurous.Stock {
    export namespace JobTransactionSelectService {
        export const baseUrl = 'Stock/JobTransactionSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<JobTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/JobTransactionSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobTransactionSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
